var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vl-style-box',[_c('vl-style-stroke',{attrs:{"width":5,"color":"#ffcc33","line-dash":[10, 10]}}),_c('vl-style-circle',{attrs:{"radius":7}},[_c('vl-style-fill',{attrs:{"color":"rgba(255, 255, 255, 0.2)"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }